<div class="map-container">
  <div id="map"></div>
</div>
